module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-editorial-blacklivesmatter-2-9e09ba6b13e3a4414544b89a680a592d.png";